module.exports = __webpack_public_path__ + "img/bg.70cf248b.png";